import React, { Suspense, useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import i18n from "./services/translations/i18n";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { Loader } from "src/components";
import { store, persistor } from "src/redux/store";
import AppRouter from "src/router";
import SkinHead from "src/components/SkinHead/SkinHead";
import { ThemeProvider } from "@mui/system";
import { muiTheme } from "src/theme/muiTheme";
import flagsmith from "flagsmith";
import { FlagsmithProvider } from "flagsmith/react";
import { LmsAnalytics } from "src/services/analytics";

function PostHogRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    LmsAnalytics.init();
  }, []);

  useEffect(() => {
    LmsAnalytics.logPageVisit(location.pathname);
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<Loader />} persistor={persistor}>
        <FlagsmithProvider
          options={{
            environmentID: "TzELU4nRo7y8GejRjoiqzz"
          }}
          flagsmith={flagsmith}
        >
          <BrowserRouter>
            <SkinHead />
            <PostHogRouteTracker />
            <I18nextProvider i18n={i18n}>
              <ThemeProvider theme={muiTheme}>
                <Suspense fallback={<Loader />}>
                  <AppRouter />
                </Suspense>
              </ThemeProvider>
            </I18nextProvider>
          </BrowserRouter>
        </FlagsmithProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
